import { render } from "./Lightbox-Document.vue?vue&type=template&id=48d65219"
import script from "./Lightbox-Document.vue?vue&type=script&lang=js"
export * from "./Lightbox-Document.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__